<script>
    import {link} from 'svelte-spa-router'
    import { t } from "../i18n.js";

    export let name
    export let description
    export let id
    export let limitedAvailability
</script>

<a href="/interfaces/{id}" use:link>
    <div class="p-4 md:py-6 border border-grey-700 hover:outline hover:outline-navy hover:outline-2 hover:border-navy hover:shadow-lg transition duration-150 relative flex flex-col items-start">
        <h3 class="text-navy mb-2">{name}</h3>
        {#if limitedAvailability}
            <span class="md:absolute top-0 right-0 md:top-1 md:right-1 bg-gray-500 px-1 py-1 text-xs border border-grey-700 md:m-2">{$t('datasource.limitedAvailability')}</span>     
        {/if}
        
        <p>{@html description}</p>
    </div>
</a>


